jQuery(document).ready(function ($) {
    const moreRoomsSlider = new Swiper('.single__more--rooms', {
        loop: true,

        slidesPerView: 1,
        slidesPerGroup: 1,

        longSwipes: false,

        spaceBetween: 24,

        pagination: {
            el: '.single__more--rooms-pagination',
            type: 'bullets',
            bulletClass: 'pagination__bullet',
            bulletActiveClass: 'active',
            clickable: true
        },

        autoplay: true,
        delay: 8000,

        breakpoints: {
            768: {
                slidesPerView: 2
            },

            1024: {
                slidesPerView: 3
            }
        }
    });
});